import { render } from "./InvestHome.vue?vue&type=template&id=323e0a91&scoped=true&ts=true"
import script from "./InvestHome.vue?vue&type=script&lang=ts"
export * from "./InvestHome.vue?vue&type=script&lang=ts"

import "./InvestHome.vue?vue&type=style&index=0&id=323e0a91&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323e0a91"]])

export default __exports__